import React, { Component } from 'react'
import { nextLevel } from 'constants/wizards'
import { meta } from 'helpers/decorators'
import { Wizard } from 'components/masters'
import { WizardProgress } from 'components/layout'
import { renderRoutes } from 'react-router-config'

@meta({
  title: 'Register Next Level'
})
class NextLevel extends Component {
  render() {
    const { route } = this.props
    const children = route && renderRoutes(route.routes)

    return (
      <Wizard
        items={nextLevel}
        wizardProgress={<WizardProgress {...this.props} />}
        {...this.props}
      >
        {children}
      </Wizard>
    )
  }
}

export default NextLevel
